import { SimilarSurvey, SimilarSurveyQualification } from '@ps/survey-utils';
import { BaseMapper } from '@ps/utils';

import {
  SimilarSurveyDto,
  SimilarSurveyQualificationDto,
} from '../dtos/similar-surveys.dto';

export class SimilarSurveyMapper extends BaseMapper<
  SimilarSurveyDto,
  SimilarSurvey
> {
  public override fromDto(dto: SimilarSurveyDto): SimilarSurvey {
    return {
      id: dto.ps_survey_id,
      companyId: dto.cmp,
      title: dto.title,
      currency: {
        fx: dto.currency.fx,
        symbol: dto.currency.symbol,
      },
      epc: dto.epc,
      cpi: dto.cpi,
      avgMargin: dto.avgMargin ?? null,
      avgScpi: dto.avgSCPI ?? null,
      completesRequired: dto.completes_required,
      fielded: dto.fielded,
      ir: dto.ir,
      loi: dto.loi,
      fieldTime: dto.field_time,
      qualifications: (dto.qualifications ?? []).map((qualification) =>
        this._toQualification(qualification),
      ),
      closedDate: dto.survey_closed_date,
    };
  }

  private _toQualification(
    dto: SimilarSurveyQualificationDto,
  ): SimilarSurveyQualification {
    return {
      qualificationCode: dto.qualification_code,
      qualificationName: dto.qualification_name,
      conditionCodes: dto.condition_codes ?? [],
    };
  }
}
